<template>
  <banner />

  <div
    class="
      min-h-screen lg:h-screen w-screen
      px-5 py-16 lg:p-16
      bg-middle-gray-600 text-middle-gray-50
      flex justify-center items-center
    "
  >
    <div
      class="
        grid grid-flow-row lg:grid-flow-col lg:items-center justify-center gap-16
      "
    >
      <article>
        <h1 class="font-medium text-6xl mb-8 font-engagement">Ceremony</h1>
        <p class="text-lg lg:text-2xl tracking-wide">
          Aidan and Kari will be married at 11:00 a.m. on August 21, 2021. The
          ceremony will take place at Hope Church in Lenox, MA.
        </p>
      </article>
      <aside class="flex flex-col gap-6 items-center w-full">
        <a-map :address="churchAddress" class="w-full lg:w-600" />
        <a-map-link :address="churchAddress" />
      </aside>
    </div>
  </div>

  <div
    class="
      min-h-screen lg:h-screen w-screen
      px-5 py-16 lg:p-16
      bg-gray-100 text-gray-800
      flex justify-center items-center
    "
  >
    <div
      class="
        grid grid-flow-row lg:grid-flow-col lg:items-center justify-center gap-16
      "
    >
      <article class="lg:col-start-2">
        <h1 class="font-medium text-6xl mb-8 font-engagement">Reception</h1>
        <p class="text-lg lg:text-2xl tracking-wide">
          A reception will follow at the family
          farm in West Stockbridge, MA.
        </p>
        <p class="mt-2 text-lg">
          <i>25 West Center Road,</i><br>
          <i>West Stockbridge, MA 01266</i>
        </p>
        <div class="text-center mt-10 mb-10">
          <a
            href="https://www.bedbathandbeyond.com/store/giftregistry/viewregistryguest/550159601"
            target="_blank"
            class="bg-tuscany-600 text-tuscany-50 px-5 py-3 rounded text-sm lowercase hover:bg-tuscany-500"
          >
            View the Registry
          </a>
        </div>
      </article>
      <aside class="flex flex-col gap-6 items-center w-full lg:col-start-1">
        <a-map :address="farmAddress" class="w-full lg:w-600" />
        <a-map-link :address="farmAddress" />
      </aside>
    </div>
  </div>
</template>

<script>
import { defineAsyncComponent, ref } from "vue";

export default {
  components: {
    Banner: defineAsyncComponent(() => import("@/components/Banner.vue")),
    AMap: defineAsyncComponent(() => import("@/components/Map.vue")),
    AMapLink: defineAsyncComponent(() => import("@/components/MapLink.vue"))
  },

  setup() {
    const churchAddress = ref("259 Kemble Street, Lenox, MA 01240");
    const farmAddress = ref("25 West Center Road, West Stockbridge, MA 01266");

    return { churchAddress, farmAddress };
  }
};
</script>
